import React from 'react';
import { useSelector } from 'react-redux';
import Layout from '../components/Layout';

const DefaultDashboard = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <Layout>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card text-center p-4 p-md-5">
              <div className="fs-1 mb-3">👋</div>
              <h1 className="fs-3 mb-2">Welcome, {user?.name}!</h1>
              <p className="text-muted mb-4">
                You're logged into the Enterprise Management System
              </p>

              <div className="card bg-light border-0 text-start p-4">
                <h3 className="fs-6 fw-semibold mb-3">Your Profile</h3>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="small fw-semibold text-muted d-block mb-1">Name</label>
                    <p className="mb-0">{user?.name}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="small fw-semibold text-muted d-block mb-1">Email</label>
                    <p className="mb-0">{user?.email}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="small fw-semibold text-muted d-block mb-1">Employee Code</label>
                    <p className="mb-0">{user?.employee_code}</p>
                  </div>
                  <div className="col-md-6">
                    <label className="small fw-semibold text-muted d-block mb-1">Role</label>
                    <p className="mb-0 text-capitalize">{user?.role}</p>
                  </div>
                  <div className="col-12">
                    <label className="small fw-semibold text-muted d-block mb-1">Departments</label>
                    <p className="mb-0 text-capitalize">
                      {user?.departments
                        ? user.departments.map((d) => d.replace(/_/g, ' ')).join(', ')
                        : user?.department?.replace(/_/g, ' ') || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DefaultDashboard;
